// Static content for JP Accounts & Tax Consultants
import {
  Calculator, BookOpen, FileText, Receipt, Percent, ChartLineUp,
  UserCircle, Laptop, Storefront, Handshake, Buildings, Briefcase,
  ShieldCheck, Clock, Lock, Tag, Headset, Wrench,
} from "@phosphor-icons/react";

export const CONTACT = {
  phones: ["9879861580", "9664755829"],
  whatsapp: ["919879861580", "919664755829"],
  email: "officejpat@gmail.com",
  address: "Ahmedabad, Gujarat, India",
};

export const SERVICES = [
  {
    icon: Calculator,
    title: "Accounting",
    items: ["Daily accounting", "Journal entries", "Ledger maintenance", "Trial Balance", "Profit & Loss", "Balance Sheet"],
  },
  {
    icon: BookOpen,
    title: "Bookkeeping",
    items: ["Transaction recording", "Purchase & Sales entries", "Expense management", "Monthly bookkeeping", "Vendor reconciliation", "Customer reconciliation"],
  },
  {
    icon: FileText,
    title: "Income Tax Return (ITR)",
    items: ["Salaried ITR", "Business ITR", "Capital Gain ITR", "Tax planning", "Notice assistance", "AIS & Form 26AS verification"],
  },
  {
    icon: Percent,
    title: "GST",
    items: ["GST Registration", "GSTR-1", "GSTR-3B", "Annual Return", "Input Tax Credit", "GST Reconciliation"],
  },
  {
    icon: Receipt,
    title: "TDS",
    items: ["TDS Calculation", "TDS Return Filing", "Form 16", "Form 16A", "Challan preparation", "Compliance"],
  },
  {
    icon: ChartLineUp,
    title: "Financial Reporting",
    items: ["Balance Sheet", "Profit & Loss", "Cash Flow", "MIS Reports", "Financial Statements", "Loan Reports"],
  },
];

export const WHO_WE_HELP = [
  { icon: UserCircle, label: "Salaried Employees" },
  { icon: Laptop, label: "Freelancers" },
  { icon: Storefront, label: "Small Business Owners" },
  { icon: Handshake, label: "Partnership Firms" },
  { icon: Buildings, label: "Private Limited Companies" },
  { icon: Briefcase, label: "Professionals (Doctors, CAs, Architects)" },
];

export const WHY_CHOOSE = [
  { icon: ShieldCheck, title: "Experienced Professionals", desc: "Qualified accounting professionals with practical industry experience." },
  { icon: Clock, title: "Timely Compliance", desc: "Never miss important filing deadlines." },
  { icon: Lock, title: "Data Security", desc: "Complete confidentiality of financial information." },
  { icon: Tag, title: "Affordable Pricing", desc: "Professional services at competitive prices." },
  { icon: Headset, title: "Personalized Support", desc: "Every client receives dedicated assistance." },
  { icon: Wrench, title: "Modern Accounting Tools", desc: "Tally Prime, QuickBooks Online, Excel & Computax." },
];

export const LEADERSHIP = [
  {
    name: "Prem Jeswani",
    role: "Co-Founder & Partner",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBmaW5hbmNlJTIwcHJvZmVzc2lvbmFsJTIwb2ZmaWNlJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzgzNDM3NzU0fDA&ixlib=rb-4.1.0&q=85",
    bio: "Prem Jeswani specializes in accounting, bookkeeping, GST compliance, Income Tax Return (ITR) filing, TDS compliance, Tally Prime, QuickBooks Online, and financial reporting. He is dedicated to helping individuals and businesses maintain accurate financial records while ensuring timely statutory compliance.",
    skills: ["Accounting", "Bookkeeping", "GST", "Income Tax", "QuickBooks", "Tally Prime"],
  },
  {
    name: "Purshottam Prajapati",
    role: "Co-Founder & Partner",
    image: "https://images.unsplash.com/photo-1589386417686-0d34b5903d23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBtYWxlJTIwYWNjb3VudGFudCUyMHByb2Zlc3Npb25hbCUyMHNtaWxpbmd8ZW58MHx8fHwxNzgzNDM3NzUzfDA&ixlib=rb-4.1.0&q=85",
    bio: "Purshottam Prajapati holds a Bachelor of Commerce degree and a Diploma in Taxation Laws & Practice. With over three years of practical experience, he specializes in accounting, GST, TDS, Income Tax, financial reporting, and business compliance.",
    skills: ["GST", "Accounting", "TDS", "Financial Reporting", "Business Compliance"],
  },
];

export const FAQS = [
  {
    q: "Which ITR form should I file?",
    a: "We help determine the correct Income Tax Return form based on your income source and tax requirements.",
  },
  {
    q: "What documents are required for ITR filing?",
    a: "PAN, Aadhaar, Form 16, Bank Statements, AIS, Form 26AS and Capital Gain Statements (if applicable).",
  },
  {
    q: "Can you help with GST returns?",
    a: "Yes. We provide complete GST compliance including registration, monthly returns, reconciliation, and annual filings.",
  },
  {
    q: "Do you provide bookkeeping services?",
    a: "Yes. We provide monthly bookkeeping for proprietorships, partnership firms, LLPs, and private limited companies.",
  },
  {
    q: "Which accounting software do you use?",
    a: "Tally Prime, QuickBooks Online, Excel and Computax.",
  },
  {
    q: "Is my financial information secure?",
    a: "Yes. All client information is treated with complete confidentiality.",
  },
];

export const TOOLS = ["Tally Prime", "QuickBooks Online", "Excel", "Computax"];

export const LOGO = "https://customer-assets.emergentagent.com/job_tax-filing-hub-37/artifacts/gqwu61v4_jp%20logo.jpeg";
